//Client/src/pages/Contact.js
import { useState } from "react";
import api from "../api/axiosInstance";
import { toast } from "react-hot-toast";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const update = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      return toast.error("Please fill all required fields");
    }

    try {
      setLoading(true);
      await api.post("/contact", form);
      toast.success("✅ Message sent successfully");

      setForm({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (e) {
      toast.error("Failed to send message");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4">
      <div className="w-full max-w-xl card-glass p-8">
        <h1 className="text-2xl font-bold mb-2">Contact Us</h1>
        <p className="text-sm text-gray-400 mb-6">
          Have a question or need help? Fill the form below.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <input
            name="name"
            value={form.name}
            onChange={update}
            className="input-glass w-full"
            placeholder="Your Name *"
          />

          <input
            name="email"
            type="email"
            value={form.email}
            onChange={update}
            className="input-glass w-full"
            placeholder="Email ID *"
          />

          <input
            name="phone"
            value={form.phone}
            onChange={update}
            className="input-glass w-full"
            placeholder="Phone Number (optional)"
          />

          <textarea
            name="message"
            value={form.message}
            onChange={update}
            rows="5"
            className="input-glass w-full resize-none"
            placeholder="Your message *"
          />

          <button
            disabled={loading}
            className="btn-primary w-full"
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}
